import { ChangeEvent, FC } from "react";
import { useTranslation } from "react-i18next";
import { Search } from "@mui/icons-material";
import { InputAdornment, TextField, TextFieldProps, debounce } from "@mui/material";

type InputSearchingProps = TextFieldProps & {
  onSearch?: (keyword: string) => void;
};

const InputSearching: FC<InputSearchingProps> = ({ label, onChange, onSearch, ...otherProps }) => {
  const { t: getLabel } = useTranslation();

  const inputLabel = label || getLabel("L_SEARCH");

  const onDebounceSeach = debounce((value: string) => {
    if (onSearch) onSearch(value);
  }, 500);

  const onChangeValue = (event: ChangeEvent<HTMLInputElement>) => {
    if (onSearch) onDebounceSeach(event.target.value);
    if (onChange) onChange(event);
  };

  return (
    <TextField
      fullWidth
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        ),
      }}
      label={inputLabel}
      type="search"
      onChange={onChangeValue}
      {...otherProps}
    />
  );
};

export default InputSearching;
